import axios from './axios'
import Qs from 'qs'

let axiosInstance = axios()
export default {
    get(url,params,headers){
        let options = {}
        if(params){
            options.params = params
        }
        if(headers){
            options.headers = headers
        }
        return axiosInstance.get(url,options)
    },
    post(url,params,headers){
        let options = {}
        if(headers){
            options.headers = headers
        }
        /*let searchStr = Qs.stringify(params)*/
        /* 解决axios 使用 URLSearchParams解析参数，导致部分低版本手机无法发请求的问题 */
        /* axios.post(url, searchStr).xxxx */
        //let newParams = new URLSearchParams();
        /* if(null != params){
            for(var key in params){
                newParams.append(key,params[key])
            }
        } */
        return axiosInstance.post(url,params,options)
    },
    put(url,params,headers){
        let options = {}
        if(headers){
            options.headers = headers
        }
        return axiosInstance.put(url,params,options)
    },
    delete(url,params,headers){
        let options = {}
        if(headers){
            options.headers = headers
        }
        if(params){
            options.params = params
        }
        return axiosInstance.delete(url,options)
    }
}



// WEBPACK FOOTER //
// ./src/api/network.js